function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import './flash-messages.scss';
import React from 'react';
import { connect } from 'react-redux';
import FlashMessage from './FlashMessage';
var FlashMessages = function FlashMessages(_ref) {
  var _dismissMessage = _ref.dismissMessage,
    styles = _ref.styles,
    messages = _ref.messages;
  if (!messages || messages.length === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles.wrapper
  }, messages.map(function (message) {
    return /*#__PURE__*/React.createElement(FlashMessage, {
      key: message.key,
      dismissMessage: function dismissMessage() {
        return _dismissMessage(message.key);
      },
      message: message
    });
  }));
};
var mapStateToProps = function mapStateToProps(_ref2, _ref3) {
  var application = _ref2.application;
  var _ref3$styles = _ref3.styles,
    styles = _ref3$styles === void 0 ? {} : _ref3$styles;
  return {
    messages: application.messages,
    styles: _objectSpread({
      wrapper: 'container flash-message-container'
    }, styles)
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    dismissMessage: function dismissMessage(key) {
      return dispatch(ownProps.dismissMessage(key));
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(FlashMessages);